import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StringHelper } from 'src/app/helpers/string-helper';
import { SoldRented } from 'src/app/model/project/sold-rented';
import { SignStickerOverview } from 'src/app/model/sign/sticker/sign-sticker-overview';
import { SignStickerControllerRequestService } from '../../../../../../services/api/sign-associations/implementations/sign-sticker-controller-request.service';
import { ProjectDisplayObservableService } from '../../../../../../services/project-display-observable.service';
import { IPBoardStickerPickerComponent } from '../../../../../../shared/project-components/helpers/ip-board-design-picker/ip-board-association-picker/ip-board-sticker-picker/ip-board-sticker-picker.component';
import IPBoardPart from '../../../../../../model/product/ip-board/ip-board-part';
import { SignStickerDetail } from 'src/app/model/sign/sticker/sign-sticker-detail';

@Component({
  selector: 'sold-rented-sticker-select',
  templateUrl: './sold-rented-sticker-select.component.html',
  styleUrls: ['./sold-rented-sticker-select.component.scss']
})
export class StickerSelectComponent extends IPBoardStickerPickerComponent
  implements OnInit {
  @Input()
  readOnly: boolean = false;

  @Input()
  soldRented?: SoldRented;

  constructor(
    protected signStickerControllerRequestService: SignStickerControllerRequestService,
    protected projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super(signStickerControllerRequestService, projectDisplayObservableService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.withSticker = true;
  }

  // Override
  protected getEmitSubProjectDesignSubject(): Subject<any> {
    return this.projectDisplayObservableService.getSubProjectDesignVariableChangedSubscribable();
  }

  protected getCurrentSelectedOption(
    ipBoardPart: IPBoardPart
  ): SignStickerOverview {
    if (this.soldRented != null && this.soldRented.id != null) {
      return this.soldRented.signSticker;
    }
    if (
      this.associationOptions != null &&
      this.associationOptions.length > 0 &&
      ipBoardPart.sticker == null
    ) {
      const option = this.associationOptions[0];
      this.setOptionValue(option);
      return option.value;
    }
    return ipBoardPart.sticker;
  }

  protected initializeOtherValue(): string {
    if (this.soldRented != null && this.soldRented.id != null) {
      return this.soldRented.otherSticker;
    }
    return this.ipBoardPart.otherSticker;
  }

  protected wasOtherOptionSelected(): boolean {
    if (this.soldRented != null && this.soldRented.id != null) {
      return (
        this.soldRented.signSticker == null &&
        !StringHelper.isEmpty(this.soldRented.otherSticker)
      );
    }
    return (
      this.ipBoardPart.sign == null ||
      (this.ipBoardPart.sticker == null &&
        !StringHelper.isEmpty(this.ipBoardPart.otherSticker))
    );
  }

  protected otherOptionHasValue(): boolean {
    if (this.soldRented != null && this.soldRented.id != null) {
      return (
        this.soldRented.signSticker == null &&
        !StringHelper.isEmpty(this.soldRented.otherSticker)
      );
    }
    return (
      this.ipBoardPart.sticker == null &&
      !StringHelper.isEmpty(this.ipBoardPart.otherSticker)
    );
  }

  protected doSetOptionValue(value: SignStickerOverview): void {
    this.soldRented.signSticker = <SignStickerDetail>value;
  }

  protected doSetOtherValue(): void {
    this.soldRented.otherSticker = this.otherValue;
  }
}
